<script>
  import { createEventDispatcher } from 'svelte';
  import Toggle from '@components/Toggle.svelte';

  const dispatch = createEventDispatcher();

  export let togglerEnabled = false;
  export let title;
  export let description;

  // If simple, there is only a title, and no slots, and slightly different styling
  export let simple = true;
  export let endOfSection = false;

  const dispatchToggled = () => {
    dispatch('toggle', { newValue: !togglerEnabled });
  };
</script>

<style style="text/scss" lang="scss">
  .advanced-settings-toggle {
    margin-top: 15px;
    display: flex;
    align-items: center;

    &.end-of-section {
      border-bottom: 1px solid rgb(238, 238, 238);
      padding-bottom: 30px;
      margin-bottom: 20px;
    }
  }

  .title-and-desc-container {
    margin-left: 25px;
    flex: 1;

    .title-container {
      display: flex;

      .title {
        font-weight: 500;
      }
    }

    .desc-container {
      margin-top: 10px;
      line-height: 24px;

      .desc {
        opacity: 0.5;
      }
    }
  }

  .simple-title {
    opacity: 0.5;
    font-size: 14px;
    font-weight: 500;
    margin-left: 25px;
  }
</style>

<div class="advanced-settings-toggle" class:end-of-section={endOfSection}>
  <Toggle enabled={togglerEnabled} on:toggled={dispatchToggled} />
  <!-- <div class="checkbox-container">
    <span
      on:click={dispatchToggled}
      class="ui-toggler"
      class:togger-enabled={togglerEnabled} />
  </div> -->

  {#if simple}
    <span class="simple-title">{title}</span>
  {:else}
    <div class="title-and-desc-container">
      <div class="title-container">
        <div class="title">{title}</div>
        <slot name="title-action" />
      </div>

      {#if description}
        <div class="desc-container">
          <span class="desc">
            {description}
          </span>
          <slot name="description-action" />
        </div>
      {/if}
    </div>
  {/if}
</div>
